/* eslint-disable import/no-cycle */
/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-29 20:03:26
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-10-21 16:46:09
 * @FilePath: /roboneo-web/src/utils/export.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  ContainerElementOptions,
  ElementName, FabricObject, Group, ImageOptions,
} from '@meitu/whee-infinite-canvas';
import useCanvasStore from '$/store/useCanvasStore';
import useCanvasObjectStore from '$/store/useCanvasObjectStore';
import { getImageExtensionFromUrl } from '$/utils/index';
import JSZip from 'jszip';
import { mtstatTrack } from '$/utils/mtstat';
import { WatermarkState } from '$/components/DownloadPreferencePopup';
import { getDocumentSuffixByType, urlToBlob } from './upload';
import { getWebpUrl } from './image';
import {
  setJpgExifUserComment, setPngExifAIGC,
} from './fileUtils';
import { downLoad, sanitizeFilename } from './download';

// 🔄 从 download.ts 重导出通用下载函数（避免代码重复）
export {
  downLoad, downloadImageUrl, sanitizeFilename, downloadFileFromUrl, parseFilenameFromContentDisposition,
} from './download';

export interface ExportData {
  name: string;
  blob: Blob;
}

export enum IMAGEType {
  PNG = 'png',
  JPEG = 'jpeg',
  SVG = 'svg',
}

// 递归获取_custom_data_history_里的指定key
function getKeyArr(data: FabricObject[], key: string = 'url') {
  const keyArr: string[] = [];

  function traverse(nodes: FabricObject[]) {
    for (const node of nodes) {
      // 文字默认没有_custom_data_history_字段，要做空判断
      if (node._custom_data_history_?.[key]) {
        keyArr.push(node._custom_data_history_[key]);
      }
      if (node._name_ === ElementName.CONTAINER) {
        traverse((node as any)._objects);
      }
    }
  }
  traverse(data);
  return keyArr.join(', ');
}

export async function getExportData({
  location,
  callback,
}: {
  location?: string;
  callback?: () => Promise<WatermarkState>;
}, type?: IMAGEType): Promise<{
    filtered: ExportData[];
    statParams: Record<string, any>;
  } | null> {
  const { render } = useCanvasStore.getState();
  if (!render) return null;
  const { currentObjects } = useCanvasObjectStore.getState();
  const newCurrentObjects = currentObjects.filter((object) => object._name_ !== ElementName.VIDEO);
  if (!newCurrentObjects || newCurrentObjects.length === 0) return null;
  const urlArr = getKeyArr(newCurrentObjects, 'url');
  const taskIdArr = getKeyArr(newCurrentObjects, 'taskId');
  const saveType: string[] = [];
  const fileType: string[] = [];
  const fileSize: number[] = [];
  let imageNum = 0;
  let textNum = 0;
  let groupNum = 0;
  let videoNum = 0;
  let existWatermarkUrl = false;
  let hasWatermark = '0';
  // 共享的回调 Promise：并发任务只触发一次回调，所有任务等待其完成
  let callbackPromise: Promise<any> | null = null;

  const allPromises = newCurrentObjects.map(async (object, index) => {
    if (object._name_ === ElementName.VIDEO) {
      if (!saveType.includes(ElementName.VIDEO)) {
        saveType.push(ElementName.VIDEO);
      }
      videoNum += 1;
    } else if (object._name_ === ElementName.IMAGE) {
      if (!saveType.includes(ElementName.IMAGE)) {
        saveType.push(ElementName.IMAGE);
      }
      imageNum += 1;
    } else if (object._name_ === ElementName.TEXT) {
      if (!saveType.includes(ElementName.TEXT)) {
        saveType.push(ElementName.TEXT);
      }
      textNum += 1;
    } else if (object._name_ === ElementName.CONTAINER) {
      if (!saveType.includes('group')) {
        saveType.push('group');
      }
      groupNum += 1;
    }
    const customData = object._custom_data_history_;
    const isContainer = object._name_ === ElementName.CONTAINER;
    if (isContainer) {
      existWatermarkUrl = (object as Group)
        .getObjects()
        .some((child) => child._name_ === ElementName.IMAGE && child._custom_data_history_?.watermarkUrl);
    }
    const { url, watermarkUrl } = customData;
    if (watermarkUrl) {
      existWatermarkUrl = true;
    }
    try {
      if (existWatermarkUrl && callback) {
        // 保证回调只触发一次，并让所有并发任务都等待其结果
        if (!callbackPromise) {
          callbackPromise = Promise.resolve(callback());
        }
        hasWatermark = await callbackPromise;
        if (hasWatermark === '2') return null;
      }

      const suffix = type || object._custom_data_history_?.suffix || 'png';
      let filename = (object as any)._shape_name_ || `export_${index + 1}`;
      if (object._name_ === ElementName.TEXT) {
        filename = (object as any).text || `export_${index + 1}`;
      }
      filename = `${filename.substring(0, 20)}.${suffix}`;
      const size = {
        width: Math.round(object.getScaledWidth()),
        height: Math.round(object.getScaledHeight()),
      };

      const blobArr = await render.Actions.exportElementToBlob((object as any), {
        includeType: [ElementName.IMAGE, ElementName.TEXT, ElementName.ELLIPSE, ElementName.ARROW, ElementName.RECTANGLE],
        exportType: suffix,
        multiplier: 1,
        quality: 1,
        callBack: (elementOption) => {
          if (hasWatermark === '0' && existWatermarkUrl) {
            if (elementOption._name_ === ElementName.IMAGE) {
              // eslint-disable-next-line no-param-reassign
              (elementOption as ImageOptions).src = getWebpUrl({ url });
            }
            if (elementOption._name_ === ElementName.CONTAINER) {
              (elementOption as ContainerElementOptions).children.forEach((child) => {
                if (child._name_ === ElementName.IMAGE && child._custom_data_history_.watermarkUrl) {
                  // eslint-disable-next-line no-param-reassign
                  (child as ImageOptions).src = getWebpUrl({ url: child._custom_data_history_.url });
                }
              });
            }
          }
          return elementOption;
        },
      }, size);
      const blob = blobArr?.[0];
      let watermarkBlob = blob;
      fileType.push(blob.type);
      fileSize.push(blob.size);
      // if (hasWatermark === '1') {
      try {
        // 根据图片类型选择不同的元数据添加方法
        if (watermarkBlob.type === 'image/png') {
          watermarkBlob = await setPngExifAIGC(watermarkBlob);
          console.log('成功添加PNG元数据');
        } else if (watermarkBlob.type === 'image/jpeg' || watermarkBlob.type === 'image/jpg') {
          watermarkBlob = await setJpgExifUserComment(watermarkBlob);
          console.log('成功添加JPEG元数据');
        } else {
          console.log('不支持的图片类型:', watermarkBlob.type);
        }
      } catch (e) {
        console.log('添加隐士元数据失败', e);
      }
      // }
      if (!blob) return null;
      return {
        name: filename,
        blob: watermarkBlob,
      };
    }
    catch (err) {
      console.warn('导出失败：', err, object);
      return null;
    }
  });
  const statParams = {
    location,
    save_type: saveType.join(','),
    image_num: imageNum,
    video_num: videoNum,
    text_num: textNum,
    group_num: groupNum,
    file_type: fileType.join(','),
    file_size: fileSize.join(','),
    url: urlArr,
    task_id: taskIdArr,
    export_format: type,
  };
  mtstatTrack('canvas_save_click', statParams);
  if (hasWatermark === '2') return null;
  const resultArr = await Promise.all(allPromises);

  // 过滤掉导出失败的项
  const filtered = resultArr.filter((item) => item !== null) as ExportData[];

  return filtered.length ? {
    filtered,
    statParams: {
      ...statParams,
      ar_mark: hasWatermark === '0' ? '0' : '1',
    },
  } : null;
}

// 右键菜单下载的数据
export async function getExportUrl({ location, callback }: {
  location: string;
  callback?: () => Promise<WatermarkState>;
}): Promise<{
    filtered: ExportData[];
    statParams: Record<string, any>;
  } | null> {
  const { currentObjects } = useCanvasObjectStore.getState();
  const newCurrentObjects = currentObjects.filter((object) => object._name_ === ElementName.VIDEO || object._name_ === ElementName.IMAGE || object._name_ === ElementName.AUDIO);
  if (!newCurrentObjects || newCurrentObjects.length === 0) return null;

  const saveType: string[] = [];
  const fileType: string[] = [];
  const fileSize: number[] = [];
  const url: string[] = [];
  const taskIdArr: string[] = [];
  let imageNum = 0;
  let videoNum = 0;
  let audioNum = 0;
  let existWatermarkUrl = false;
  let hasWatermark = '0';
  // 共享的回调 Promise：并发任务只触发一次回调，所有任务等待其完成
  let callbackPromise: Promise<any> | null = null;

  const allPromises = newCurrentObjects.map(async (item) => {
    if (item._name_ === ElementName.VIDEO) {
      if (!saveType.includes(ElementName.VIDEO)) {
        saveType.push('video');
      }
      videoNum += 1;
    } else if (item._name_ === ElementName.IMAGE) {
      if (!saveType.includes(ElementName.IMAGE)) {
        saveType.push('image');
      }
      imageNum += 1;
    } else if (item._name_ === ElementName.AUDIO) {
      if (!saveType.includes(ElementName.AUDIO)) {
        saveType.push('audio');
      }
      audioNum += 1;
    }

    const customData = item._custom_data_history_;
    const { url: customDataUrl, watermarkUrl } = customData;

    if (watermarkUrl) {
      existWatermarkUrl = true;
    }

    try {
      if (existWatermarkUrl && callback) {
        // 保证回调只触发一次，并让所有并发任务都等待其结果
        if (!callbackPromise) {
          callbackPromise = Promise.resolve(callback());
        }
        hasWatermark = await callbackPromise;
        if (hasWatermark === '2') return null;
      }
      url.push(hasWatermark === '1' && watermarkUrl ? watermarkUrl : customDataUrl);
      taskIdArr.push(item._custom_data_history_.taskId);
      const blob = await urlToBlob(hasWatermark === '1' && watermarkUrl ? watermarkUrl : customDataUrl);
      fileType.push(blob.type);
      fileSize.push(blob.size);
      console.log(blob.type, 'blob.type------------');
      const blobType = blob.type.split('/')[1];
      let suffix = '';
      // 获取后缀
      if (item._name_ === ElementName.VIDEO) {
        suffix = 'mp4';
        if (blobType === 'quicktime') {
          suffix = 'mov';
        }
        // TODO: 暂时处理动图后缀。等后续添加画布动图元素再另判断
        if (item.frameType === 'dynamicPicture') {
          suffix = getImageExtensionFromUrl(hasWatermark === '1' && watermarkUrl ? watermarkUrl : customDataUrl).extension || 'gif';
        }
      }
      if (item._name_ === ElementName.IMAGE) {
        suffix = blobType || 'png';
      }
      if (item._name_ === ElementName.AUDIO) {
        suffix = getDocumentSuffixByType(blob.type);
      }

      return {
        name: `${(item as any)._shape_name_}.${suffix}`,
        blob,
      };
    } catch (err) {
      console.warn('导出失败：', err);
      return null;
    }
  });
  const resultArr = await Promise.all(allPromises);

  // 过滤掉导出失败的项
  const filtered = resultArr.filter((item) => item !== null) as ExportData[];
  const statParams = {
    location,
    save_type: saveType.join(','),
    image_num: imageNum,
    video_num: videoNum,
    audio_num: audioNum,
    file_type: fileType.join(','),
    file_size: fileSize.join(','),
    url: url.join(','),
    task_id: taskIdArr.join(','),
  };
  mtstatTrack('canvas_save_click', statParams);
  if (hasWatermark === '2') return null;

  return filtered.length ? {
    filtered,
    statParams: { ...statParams, ar_mark: hasWatermark === '0' ? '0' : '1' },
  } : null;
}

// ✅ downLoad 已从 download.ts 导出（见文件顶部）

export const forceDownload = async (href: string, name?: string) => {
  const res = await fetch(href);
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = blobUrl;
  if (name) {
    a.download = name;
  }
  a.click();
};

// 格式化时间 补零
export function getYMDHM() {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const minute = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  return `${year}${month}${day}${hour}${minute}`;
}
// ✅ sanitizeFilename 已从 download.ts 导出（见文件顶部）
export function getUniqueFilename(filename: string, nameMap: Map<string, number>): string {
  if (!nameMap.has(filename)) {
    nameMap.set(filename, 1);
    return filename;
  }

  const count = nameMap.get(filename)!;
  const extIndex = filename.lastIndexOf('.');
  const base = extIndex !== -1 ? filename.slice(0, extIndex) : filename;
  const ext = extIndex !== -1 ? filename.slice(extIndex) : '';
  const newName = `${base}(${count})${ext}`;

  nameMap.set(filename, count + 1);
  return getUniqueFilename(newName, nameMap); // 防止生成的名字也已存在
}
export interface DownloadImagesOptions {
  createZipName?: () => string;
}
export async function downloadImages(data: ExportData[], statParams: Record<string, any>, options?: DownloadImagesOptions) {
  const uploadFile = data;
  if (uploadFile.length > 1) {
    const zip = new JSZip();
    const nameMap = new Map<string, number>();

    uploadFile.forEach((item) => {
      if (item.blob) {
        const sanitized = sanitizeFilename(item.name);
        const uniqueName = getUniqueFilename(sanitized, nameMap);
        zip.file(uniqueName, item.blob);
      }
    });
    await zip.generateAsync({ type: 'blob' }).then(async (content: Blob) => {
      await downLoad(URL.createObjectURL(content), `${options?.createZipName?.() || `RoboNeo-${getYMDHM()}`}.zip`);
      mtstatTrack('canvas_save_success', {
        ...statParams,
      });
    }).catch((err) => {
      mtstatTrack('canvas_save_fail', {
        ...statParams,
      });
    });
  } else {
    console.log('uploadFile', uploadFile[0].name);
    await downLoad(URL.createObjectURL(uploadFile[0].blob), uploadFile[0].name);
    mtstatTrack('canvas_save_success', {
      ...statParams,
    });
  }
}
